(function() {
  window.bxsi = window.bxsi || {};

  const drawer = {
    el: null,
    backdrop: null,
    isOpen: false,

    init() {
      this.el = document.getElementById('bxsi-cart-drawer');
      if (!this.el) return;

      this.backdrop = this.el.querySelector('[data-cart-drawer-backdrop]');
      this.setupListeners();
    },

    setupListeners() {
      // Trigger buttons
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-cart-drawer-trigger]')) {
          e.preventDefault();
          this.open();
        }
        if (e.target.closest('[data-cart-drawer-close]')) {
          e.preventDefault();
          this.close();
        }
      });

      // Backdrop click
      if (this.backdrop) {
        this.backdrop.addEventListener('click', () => this.close());
      }

      // Toetsenbord: ESC sluit, Tab blijft binnen de drawer (focus-trap)
      document.addEventListener('keydown', (e) => {
        if (!this.isOpen) return;
        if (e.key === 'Escape') { this.close(); return; }
        if (e.key === 'Tab') {
          const focusables = this.el.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
          );
          const list = Array.prototype.filter.call(focusables, (el) => el.offsetParent !== null);
          if (!list.length) return;
          const first = list[0];
          const last = list[list.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });

      // Route changes (AJAX-based navigation)
      document.addEventListener('bxsi:route:change', () => {
        this.close();
      });
    },

    async open() {
      if (this.isOpen) return;

      try {
        await this.fetchCart();
        this.lastFocused = document.activeElement;
        this.el.classList.add('active');
        this.el.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        this.isOpen = true;
        // Initiële focus naar de sluit-knop (focus-management voor a11y)
        const closeBtn = this.el.querySelector('[data-cart-drawer-close]');
        if (closeBtn) closeBtn.focus();
      } catch (err) {
        console.error('Cart drawer open failed:', err);
      }
    },

    close() {
      if (!this.isOpen) return;

      this.el.classList.remove('active');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      this.isOpen = false;
      // Focus terug naar het element dat de drawer opende
      if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
        this.lastFocused.focus();
      }
    },

    async fetchCart() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        this.render(cart);
      } catch (err) {
        console.error('Failed to fetch cart:', err);
      }
    },

    render(cart) {
      const itemsContainer = this.el.querySelector('[data-cart-items]');
      const countBadge = document.querySelector('[data-cart-count]');
      const emptyMsg = this.el.querySelector('[data-cart-empty]');

      if (!itemsContainer) return;

      if (cart.items.length === 0) {
        document.dispatchEvent(
          new CustomEvent('bxsi:cart:rendered', { detail: { cart: cart } })
        );
        itemsContainer.innerHTML = '';
        if (emptyMsg) emptyMsg.classList.remove('hidden');
        if (countBadge) { countBadge.textContent = '0'; countBadge.classList.add('hidden'); }
        this.updateTotals(0, 0);
        const deliveryEmpty = this.el.querySelector('[data-cart-delivery]');
        if (deliveryEmpty) deliveryEmpty.classList.add('hidden');
        return;
      }

      if (emptyMsg) emptyMsg.classList.add('hidden');

      itemsContainer.innerHTML = cart.items
        .map(item => this.renderItem(item))
        .join('');

      // Update count
      if (countBadge) {
        countBadge.textContent = cart.item_count;
        countBadge.classList.toggle('hidden', cart.item_count === 0);
      }

      // Update totals (subtotal + total) - anders blijft de footer op €0,00 staan
      this.updateTotals(
        cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price,
        cart.total_price
      );

      // Levering-keuze tonen + bewerkbaar (zelfde cart-attribuut als /cart)
      this.renderDelivery(cart);

      // Upsell bijwerken op basis van de nieuwe mand
      document.dispatchEvent(
        new CustomEvent('bxsi:cart:rendered', { detail: { cart: cart } })
      );

      // Attach qty handlers - data-qty-set bevat de NIEUWE absolute hoeveelheid
      itemsContainer.querySelectorAll('[data-qty-set]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const key = btn.dataset.cartItemKey;
          const qty = parseInt(btn.dataset.qtySet, 10);
          this.updateQty(key, qty);
        });
      });

      // Attach remove handlers
      itemsContainer.querySelectorAll('[data-remove-item]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const key = btn.dataset.removeItem;
          this.updateQty(key, 0);
        });
      });
    },

    renderDelivery(cart) {
      const box = this.el.querySelector('[data-cart-delivery]');
      if (!box) return;
      // De waarden moeten LETTERLIJK gelijk zijn aan die in templates/cart.liquid,
      // anders raken de lade en de winkelwagenpagina uit elkaar op hetzelfde cart-attribuut.
      // Herzien 2026-08-20: levering naar Spanje is weer een dienst van Brouwers, dus de derde
      // waarde is veranderd van 'Zelf transport naar Spanje regelen' naar 'Levering naar Spanje'.
      const NEDERLAND = 'Leveren in Nederland of Belgie';
      const AFHALEN = 'Afhalen in Tilburg';
      const SPANJE = 'Levering naar Spanje';
      // CRO 2026-10-06: zonder gekozen attribuut volgt de default het land van de bezoeker (data-default uit Liquid).
      const current = (cart.attributes && cart.attributes.Levering) || box.dataset.default || NEDERLAND;
      const opt = (value, title, sub) => `
        <label class="flex items-start gap-2 cursor-pointer">
          <input type="radio" name="bxsi-drawer-levering" value="${value}" class="mt-0.5" style="accent-color:#C96F4A;" ${current === value ? 'checked' : ''}>
          <span class="text-sm text-[#0A2540]">${title}<br><span class="text-xs text-[#6E6457]">${sub}</span></span>
        </label>`;
      box.innerHTML = `
        <fieldset class="border border-[#0A2540]/10 rounded-lg p-3 space-y-2">
          <legend class="text-xs font-medium text-[#0A2540] px-1 uppercase tracking-wide">Levering</legend>
          ${opt(NEDERLAND, 'Leveren in Nederland of Belgi&euml;', 'Gratis binnen 100 km in Nederland. Daarbuiten &euro; 150, West-Vlaanderen &euro; 150, overig Belgi&euml; &euro; 250.')}
          ${opt(AFHALEN, 'Afhalen in Tilburg', 'Gratis, Polluxstraat 25 - af fabriek')}
          ${opt(SPANJE, 'Levering naar Spanje', 'Wij regelen het transport. Prijs en planning spreekt u af met de vervoerder.')}
          ${current === SPANJE ? `
            <p class="text-xs text-[#6E6457] pt-1">
              Nog een paar gegevens nodig om u te kunnen bellen:
              <a href="/cart" class="underline text-[#0A2540]">vul ze in de winkelwagen in</a>.
            </p>` : ''}
        </fieldset>`;
      box.classList.remove('hidden');
      box.querySelectorAll('input[name="bxsi-drawer-levering"]').forEach(input => {
        input.addEventListener('change', () => this.updateAttribute('Levering', input.value));
      });
    },

    async updateAttribute(name, value) {
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { [name]: value } })
        });
        if (res.ok) {
          if (window.toast) window.toast('Levering bijgewerkt', 'info', 2000);
          await this.fetchCart();
        }
      } catch (err) {
        console.error('Levering bijwerken mislukt:', err);
      }
    },

    money(cents) {
      return '€' + ((cents || 0) / 100).toLocaleString('nl-NL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    updateTotals(subtotalCents, totalCents) {
      const sub = document.getElementById('bxsi-cart-subtotal');
      const tot = document.getElementById('bxsi-cart-total');
      if (sub) sub.textContent = this.money(subtotalCents);
      if (tot) tot.textContent = this.money(totalCents);
    },

    renderItem(item) {
      const price = this.money(item.price);
      const total = this.money(item.final_line_price != null ? item.final_line_price : item.price * item.quantity);
      const props = item.properties || {};
      // Geconfigureerde boxspring: Model = titel, _img = modelfoto, overige props = samenstelling.
      const isConfig = !!props.Model || !!props._img;
      const title = props.Model || item.title;
      const imgUrl = props._img ? props._img : ((item.featured_image && item.featured_image.url) || item.image || '');
      const specs = Object.entries(props).filter(([k, v]) => v && !k.startsWith('_') && k !== 'Model');
      const specHtml = specs.length
        ? (isConfig ? `<p class="text-xs font-medium text-navy/80 mt-1.5 mb-0.5">Samenstelling</p>` : '') +
          specs.map(([k, v]) => `<p class="text-xs text-navy/60">${k}: ${v}</p>`).join('')
        : '';
      const variantLine = (!isConfig && item.variant_title) ? `<p class="text-xs text-navy/60">${item.variant_title}</p>` : '';

      return `
        <div class="border-b border-navy/20 py-4 flex gap-4" data-cart-item="${item.key}">
          <img src="${imgUrl}" alt="${title}" class="w-24 h-24 object-cover rounded bg-cream" />
          <div class="flex-1 min-w-0">
            <h4 class="font-semibold text-sm text-navy">${title}</h4>
            ${variantLine}
            ${specHtml}
            <p class="text-sm font-medium text-navy mt-2">${price}</p>
            <div class="flex items-center gap-2 mt-3">
              <button data-qty-set="${Math.max(0, item.quantity - 1)}" data-cart-item-key="${item.key}" aria-label="Aantal verlagen" class="inline-flex items-center justify-center min-w-11 min-h-11 border border-navy/20 rounded hover:bg-cream transition-colors">−</button>
              <span class="w-8 text-center text-sm">${item.quantity}</span>
              <button data-qty-set="${item.quantity + 1}" data-cart-item-key="${item.key}" aria-label="Aantal verhogen" class="inline-flex items-center justify-center min-w-11 min-h-11 border border-navy/20 rounded hover:bg-cream transition-colors">+</button>
              <button data-remove-item="${item.key}" class="ml-auto inline-flex items-center min-h-11 px-2 text-xs text-navy/60 hover:text-red-600 transition-colors">Verwijder</button>
            </div>
          </div>
          <div class="text-right">
            <p class="text-sm font-semibold text-navy">${total}</p>
          </div>
        </div>
      `;
    },

    async updateQty(key, qty) {
      try {
        const updates = { [key]: qty };
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });

        if (res.ok) {
          document.dispatchEvent(
            new CustomEvent('bxsi:cart:changed', {
              detail: { key, qty }
            })
          );
          if (window.toast && qty > 0) {
            window.toast('Hoeveelheid bijgewerkt', 'info', 2000);
          }
          await this.fetchCart();
        }
      } catch (err) {
        console.error('Failed to update cart:', err);
        if (window.toast) {
          window.toast('Fout bij bijwerken winkelmand', 'error', 3000);
        }
      }
    }
  };

  window.bxsi.cartDrawer = drawer;

  document.addEventListener('DOMContentLoaded', () => {
    drawer.init();
  });

  // ATC integration: open drawer after product added
  document.addEventListener('bxsi:cart:added', () => {
    drawer.open();
  });
})();
